// extracted by mini-css-extract-plugin
export var bottomSection = "new-menu-item-module--bottomSection--b8d20";
export var button = "new-menu-item-module--button--ca112";
export var buttonClick = "new-menu-item-module--buttonClick--e85a2";
export var buttonClicking = "new-menu-item-module--buttonClicking--d890c";
export var description = "new-menu-item-module--description--9ef69";
export var menuItem = "new-menu-item-module--menu-item--0b022";
export var price = "new-menu-item-module--price--b76c6";
export var subName = "new-menu-item-module--subName--4d47c";
export var title = "new-menu-item-module--title--16c39";
export var topSection = "new-menu-item-module--topSection--ffc68";